module.exports = __webpack_public_path__ + "img/carac-princ.780c730d.jpg";